import * as React from 'react'
import * as ReactDOM from 'react-dom'
import CssBaseline from '@material-ui/core/CssBaseline'
import { AppContainer } from 'react-hot-loader'
import TraplinkedBase from './traplinked-base'
import { Provider } from 'react-redux'
import { QueryClient, QueryClientProvider } from 'react-query'
import store from './store'
const queryClient = new QueryClient()

ReactDOM.render(
    <AppContainer>
        <QueryClientProvider client={queryClient}>
            <CssBaseline />
            <Provider store={store}>
                <TraplinkedBase />
            </Provider>
        </QueryClientProvider>
    </AppContainer>,
    document.getElementById('traplinked-root')
)
